const PROFILE_PHOTO_TYPES = ['image/jpeg', 'image/png'] as const;
const PROFILE_PHOTO_MAX_SIZE = 2 * 1024 * 1024;

export function isSupportedProfilePhoto(file: File): boolean {
  return PROFILE_PHOTO_TYPES.includes(file.type as (typeof PROFILE_PHOTO_TYPES)[number]);
}

export function isSupportedProfilePhotoSize(file: File): boolean {
  return file.size <= PROFILE_PHOTO_MAX_SIZE;
}

export function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
